module.exports = __webpack_public_path__ + "static/media/thumb.aaafa08f.jpg";